import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import utils from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import Messages from '../utils/Messages';

class SituacaoFuncionalController {

  public static NRSITUFUNCM_TRABALHO = 1;

  /**
   * Rotina responsável por obter a última situação funcional de um determinado vínculo em um período de apuração
   * 
   * @param nrOrg 
   * @param nrVinculo 
   * @param nrPeriodoApuracao 
   */
  public static async getUtlimaSituacaoFuncional(nrOrg: number, nrVinculo: number, nrPeriodoApuracao: number): Promise<any> {
    try {

      const response = await HttpRequest.post('getUltimaSituacaoFuncional', {
        requestType: 'Row',
        row: {
          NRVINCULOM: nrVinculo,
          NRORG: nrOrg,
          NRPERIODOAPURACACAO: nrPeriodoApuracao,
        },
      });

      if (!response.data.dataset.data) {
        SnackbarUtils.showMessage(Messages.SF_GET_ERROR, SnackbarUtils.TYPE_ERROR);
        return null;
      }

      return response.data.dataset.data;

    } catch (err) {
      const message = err.response ? err.response.data.error :  Messages.GENERIC_ERROR;
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }
  }

  /**
   * Rotina responsável por obter os períodos de estabilidade de um vínculo específico
   * 
   * @param nrOrg 
   * @param nrVinculo 
   */
  public static async getPeriodosEstabilidade(nrOrg: number, nrVinculo: number): Promise<any> {
    try {

      const response = await HttpRequest.post('getPeriodosEstabilidade', {
        requestType: 'Row',
        row: {
          NRVINCULOM: nrVinculo,
          NRORG: nrOrg,
        },
      });

      if (!response.data.dataset.data) {
        SnackbarUtils.showMessage(Messages.ESTAB_GET_ERROR, SnackbarUtils.TYPE_ERROR);
        return null;
      }

      return response.data.dataset.data;

    } catch (err) {
      const message = err.response ? err.response.data.error :  Messages.GENERIC_ERROR;
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }
  }

  /**
   * Validação de Situação Funcional.
   * Caso Última Situação Funcional === 'Trabalho'; isValid = true
   * Qualquer outro: isValid = false, message = #Mensagem de status#
   * 
   * @param nrOrg 
   * @param nrVinculo 
   * @param nrPeriodoApuracao 
   */
  public static async validaUltSituFuncDiferenteTrabalho(nrOrg: number, nrVinculo: number, nrPeriodoApuracao: number): Promise<{ isValid: boolean, message: string }> {
    const response: any = {
      isValid: true,
      message: null,
    };

    const situFuncAtual = await this.getUtlimaSituacaoFuncional(nrOrg, nrVinculo, nrPeriodoApuracao);
    if (utils.isEmptyOrBlank(situFuncAtual)) {
      return response;
    }

    if (situFuncAtual.NRSITUFUNCM != this.NRSITUFUNCM_TRABALHO) {
      response.isValid = false;
      response.message =
        `Atenção! A situação funcional do vínculo é <strong>'${situFuncAtual.NRSITUFUNCM} - ${situFuncAtual.NMSITUFUNCH}'</strong>. Deseja prosseguir com este processo?`;
      return response;
    }

    return response;
  }

  /**
   * Validação de Período de Estabilidade.
   * 
   * @param nrOrg 
   * @param nrVinculo 
   */
  public static async validaDataRescisaoPeriodoEstabilidade(nrOrg: number, nrVinculo: number, dataRescisao: string, periodosEstabVinc: any[] = null, isDp: boolean = false): Promise<{ isValid: boolean, message: string }> {
    const response: any = {
      isValid: true,
      message: null,
    };

    // Sem necessidade de validacao
    if (utils.isEmptyOrBlank(dataRescisao)) {
      return response;
    }

    const dataRescisaoDate = DateUtil.stringToDate(dataRescisao);

    // Sem necessidade de validacao
    const periodosEstab = utils.isEmptyOrBlank(periodosEstabVinc) && !Array.isArray(periodosEstabVinc)? await this.getPeriodosEstabilidade(nrOrg, nrVinculo) : periodosEstabVinc;
    if (utils.isEmptyOrBlank(periodosEstab) || !Array.isArray(periodosEstab)) {
      return response;
    }

    // Propriedades esperadas para validacao do periodo de estabilidade
    const neededProperties = [
      'DTINIESTABVINC',
      'DSMOTIVOESTAB',
    ];

    for (const periodoEstab of periodosEstab) {
      
      for(const property of neededProperties) {
        if (!periodoEstab.hasOwnProperty(property)) {
          return response;
        }
      }

      const dataIniPeriodo = DateUtil.dateTimeStringToDateTruncate(periodoEstab.DTINIESTABVINC);
      const dataFimPeriodo = periodoEstab.DTFIMESTABVINC ? DateUtil.dateTimeStringToDateTruncate(periodoEstab.DTFIMESTABVINC) : null;
      const dataFimNotDefined = dataFimPeriodo === null;

      if (dataRescisaoDate >= dataIniPeriodo && (dataFimNotDefined || dataRescisaoDate <= dataFimPeriodo)) {
        response.isValid = false;
        response.message = `Atenção! O vínculo possui um período de estabilidade ${
          dataFimNotDefined
            ? `a partir de <strong>${DateUtil.dateTimeStringToDateString(periodoEstab.DTINIESTABVINC)}</strong>`
            : `entre <strong>${DateUtil.dateTimeStringToDateString(periodoEstab.DTINIESTABVINC)} à ${DateUtil.dateTimeStringToDateString(periodoEstab.DTFIMESTABVINC)}</strong>`
        }${
          periodoEstab.DSMOTIVOESTAB ? ` devido a ${periodoEstab.DSMOTIVOESTAB}` : ''
        }${
          isDp ? '. Deseja prosseguir com este processo?' : ''
        }`;
        return response;
      }
    }

    return response;
  }

}

export default SituacaoFuncionalController;
